module.exports = __webpack_public_path__ + "static/media/Instagram.110e7a3b.svg";